import { getActionTypes } from 'redux/utils/Form'

export default getActionTypes('REFERRAL_REQUEST_DECLINE')